import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Breakpoint, Divider, Stack, TextAlpha } from '@yonderland/andes-react';
import { useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ContentOverviewForm, initialValuesContentOverviewForm, } from '../../components/content-lister/content-overview-form/ContentOverviewForm';
import { contentOverviewActions } from '../../redux/content/actions/ContentActions.creators';
import { makeGetSearchTerm } from '../../redux/url/selectors/UrlSelectors';
import { getQuerystringByName } from '../../util/URLParamUtil';
const SEARCH_QUERY_PARAM = 'searchTerm';
const ContentListerHeadingContainer = ({ hideTitle, title, hideSearch, }) => {
    const dispatch = useDispatch();
    const reduxSearchTerm = useSelector(makeGetSearchTerm()) || '';
    const urlSearchTerm = typeof window !== 'undefined' ? getQuerystringByName(window.location.search, SEARCH_QUERY_PARAM) || '' : '';
    const searchTerm = reduxSearchTerm || urlSearchTerm;
    const initialValues = useMemo(() => ({ contentSearch: searchTerm }), [searchTerm]);
    const [valueChanged, setValueChanged] = useState(false);
    const handleResetValues = () => {
        setValueChanged(false);
        dispatch(contentOverviewActions.findContentAction(initialValuesContentOverviewForm.contentSearch));
    };
    const onSearchChange = () => setValueChanged(true);
    const handleSubmitSearch = (values) => {
        if (valueChanged && values.contentSearch !== initialValuesContentOverviewForm.contentSearch) {
            dispatch(contentOverviewActions.findContentAction(values.contentSearch));
            setValueChanged(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, { justify: hideTitle ? 'end' : 'between', children: [!hideTitle && (_jsx(TextAlpha, { as: "h1", variant: "subheadingL", children: title })), !hideSearch && (_jsx(Breakpoint, { from: "lg", children: _jsx(ContentOverviewForm, { initialValues: initialValues, onSubmit: handleSubmitSearch, handleResetValues: handleResetValues, onSearchChange: onSearchChange }) }))] }), _jsx(Breakpoint, { from: "md", children: _jsx(Box, { paddingBlock: { base: '1', lg: '2' }, children: _jsx(Divider, {}) }) })] }));
};
export default ContentListerHeadingContainer;
